import { ShippingType } from '../../core/settings';
import { BaseModel } from '../../global/models';
import { StoredFile } from "../../global/models/stored-file.models";

export interface ShippingLabel extends BaseModel { //XA: New 12/oct/2020
  // on client create:
  status: ShippingLabelStatus,
  orderId: string,
  // on server update:
  errorMessage?: string,
  file: StoredFile,
  request: any,
  response: any,

  //new Xav added
  tracking?: any,
  shippingType: ShippingType;
  shippingCourier?: ShippingCourier;
  shippingCourierService?: ShippingCourierService;
}

export enum ShippingLabelStatus { PROCESSING = 'processing', SUCCESS = 'success', FAILED = 'failed' }

export enum ShippingCourier {
  NONE = 'none', // on local pick-up, courier is none
  CEX = 'cex', // correos express
  MRW = 'mrw', // mrw
  GLS = 'gls', // gls
  SENDING = 'sending', // sending courier,
  CORREOS = 'correos',
  INPOST = 'inpost',
}

// contract name on different couriers
export enum ShippingCourierService {
  NONE = 'none', // on local pick-up, courier service is none
  // https://www.correosexpress.com/web/correosexpress/nacional
  CEX_PAQ_24 = 'cex_paq_24', // CEX=  standard shipping=  24-48 h
  CEX_PAQ_14 = 'cex_paq_14', // CEX=  urgent shipping=  next day <14h
  CEX_PAQ_PUNTO = 'cex_paq_punto', // CEX=  pick-up point
  // https://www.sending.es/servicios/#transporte
  // Sending=  El servicio depende de cual queráis usar para ese envío.
  // El 01 es para Send Exprés, el 02 para Send Top 10h,
  // el 18 para Send Marítimo, y el 17 para Send Internacional Carga
  SENDING_SEND_EXPRESS = 'sending_send_express', // SENDING=  next day <14h (01)
  SENDING_SEND_TOP = 'sending_send_top', // SENDING=  next day <10h (02)
  MRW_URGENT_14_EXPEDITION = 'mrw_urgent_14_expedition',
  MRW_URGENT_19_EXPEDITION = 'mrw_urgent_19_expedition',
  MRW_ECOMMERCE = 'mrw_ecommerce',
  GLS_BUSINESS_PARCEL = 'gls_business_parcel',
  GLS_EXPRESS = 'gls_express',
  'CORREOS_PREMIUM_DOMICILIO' = 'correos_premium_domicilio',
  'CORREOS_PREMIUM_OFICINA' = 'correos_premium_oficina',
  'CORREOS_PREMIUM_CITYPAQ' = 'correos_premium_citypaq',
  INPOST_24R = 'inpost_24r',
  LOCAL = 'local',
}
